'use client'

import React from 'react'
import cx from 'classnames'
import { Menu, MenuItem } from '@headlessui/react'
import { Message } from '@locmod/intl'

import { Dropdown } from 'components/inputs'
import { Icon } from 'components/ui'
import {
  useOddsView,
  oddsViews,
  type OddsView,
  useTimeFormat,
  timeFormats,
  type TimeFormat,
} from 'contexts'
import messages from './messages'

const Content: React.FC = () => {
  const { oddsView, setOddsView } = useOddsView()
  const { timeFormat, setTimeFormat } = useTimeFormat()

  return (
    <div className="ds:w-[200px] bg-accent-grey-700 p-2 rounded-[8px] shadow-lg">
      <div className="mb-2">
        <div className="text-base font-semibold text-white mb-2.5 border-b-[0.25px] border-[#737373] pb-2.5 px-3 ">
          <Message value={messages.oddsFormat} />
        </div>
        {Object.keys(oddsViews).map(value => {
          const title = oddsViews[value]
          const isActive = value === oddsView

          const oddClassName = cx(
            'py-2.5 px-3 rounded-lg cursor-pointer w-full text-left flex items-center justify-between',
            {
              'text-white bg-[#1B1A17] rounded-[8px]': isActive,
              'text-accent-grey-200 hover:text-white': !isActive,
            }
          )

          return (
            <MenuItem key={value}>
              <button
                className={oddClassName}
                onClick={() => setOddsView(value as OddsView)}
              >
                <Message className="text-sm font-medium" value={title} />
                {isActive && (
                  <Icon className="size-5" name="interface/accepted" />
                )}
              </button>
            </MenuItem>
          )
        })}
      </div>

      <div>
        <div className="text-base font-semibold text-white mb-2.5 border-b-[0.25px] border-[#737373] pb-2.5 px-3">
          <Message value={messages.timeFormat} />
        </div>
        {Object.keys(timeFormats).map(value => {
          const title = timeFormats[value]
          const isActive = value === timeFormat

          const timeClassName = cx(
            'py-2.5 px-3 rounded-lg cursor-pointer w-full text-left flex items-center justify-between',
            {
              'text-white bg-[#1B1A17] rounded-[8px]': isActive,
              'text-accent-grey-200 hover:text-white': !isActive,
            }
          )

          return (
            <MenuItem key={value}>
              <button
                className={timeClassName}
                onClick={() => setTimeFormat(value as TimeFormat)}
              >
                <Message className="text-sm font-medium" value={title} />
                {isActive && (
                  <Icon className="size-5" name="interface/accepted" />
                )}
              </button>
            </MenuItem>
          )
        })}
      </div>
    </div>
  )
}

const SettingsDropdown: React.FC = () => {
  return (
    <Dropdown
      buttonClassName="h-5"
      content={<Content />}
      placement="bottomRight"
      dropListClassName="mt-2"
    >
      <div>
        <Icon
          className="size-5 text-accent-grey-200 hover:text-white"
          name="interface/settings"
        />
      </div>
    </Dropdown>
  )
}

export default SettingsDropdown
